import React from "react";
//Helpers
import moment from 'moment';
import { GetFormatForMoment } from 'Core/data/Helpers';
// Components
import { Grid } from "@mui/material";
import Pill from "Components/Pill";
import styles from "Assets/sass/core/vars.scss";
import "./styles.scss";

const Row = (props) => {
  const {
    messages,
    data: { createdOn, username, ip, attemptResult },
    user
  } = props;

  const renderDate = (createdOn) => {
    return (
      <span>
        {moment.unix(parseInt(createdOn)).format(`${GetFormatForMoment(user.dateformat)} hh:mm A z`)}
      </span>
    );
  };

  const renderAttempt = (attemptResult) => {
    let attempt;
    let color;
    switch (attemptResult) {
      case "SUCCESSFUL_LOGIN":
        color = styles.green;
        attempt = messages["loginHistory_successful"];
        break;
      default:
        color = styles.red;
        attempt = messages["loginHistory_failed"];
        break;
    }
    return (
      <Pill style={{ width: 110 }} item={{ name: attempt, color: color }} />
    );
  };

  return (
    <Grid container className="login-history-row">
      <Grid container item xs={3}>
        {renderDate(createdOn)}
      </Grid>
      <Grid container item xs={3}>
        <span>{username}</span>
      </Grid>
      <Grid container item xs={3}>
        <span>{ip}</span>
      </Grid>
      <Grid container item xs={3}>
        {renderAttempt(attemptResult)}
      </Grid>
    </Grid>
  );
};

export default Row;
